import { useEffect, useState } from "react";
import { getFetcher, postFetcher } from "../../../api/fetchers.ts";
import { endpoints } from "../../../api/endpoints.ts";
import { Tooltip } from "flowbite-react";
import { calculateDiscountedPrice } from "../../utils/functions.tsx";
import { useUser } from "../../context/UserContext.tsx";
import { ToastContainer, toast } from "react-toastify";
import Spinner from "../../components/spinner/Spinner.tsx";
import { useFormik } from "formik";
import * as Yup from "yup";
import { parseStatics } from "../../function/parseStatics.tsx";
import { useLanguage } from "../../context/LanguageContext.tsx";
import { useCurrency } from "../../context/CurrencyContext.tsx";

interface IContract {
  key: string;
  value: string;
}
interface BasketResponse {
  result: boolean;
  basketItems: BasketItem[];
}
interface BasketItem {
  id: string;
  userId: string;
  productId: string;
  quantity: number;
  attributes: string;
  isCampaign: boolean;
  status: boolean;
  dailyCampaignId: string | null;
  companyCampaignId: string | null;
  createdAt: string;
  updatedAt: string;
  product: Product;
  bulkDiscount: boolean;
}

interface Product {
  id: string;
  name: string;
  brand: string;
  price: number;
  description: string;
  attributes: string;
  images: string;
  supplierId: string;
  categoryId: number;
  subCategoryId: number;
  stock: number;
  rating: number;
  discount: number;
  isFeatured: boolean;
  isFlash: boolean;
  coupon: number;
  status: boolean;
  createdAt: string;
  updatedAt: string;
  bulkDiscounts?: any;
  Supplier: any;
  code: any;
}

interface B2B {
  id: string;
  name: string;
  ratio: number;
}

const SafePayment = () => {
  const { t } = useLanguage();
  const { exchangeRate, currencySymbol, currency } = useCurrency();
  const { user } = useUser();
  const [couponCode, setCouponCode] = useState<string>("");

  const [basketData, setBasketData] = useState<BasketResponse | null>(null);
  const [totalPriceLast, setTotalPriceLast] = useState<number>(0);
  const [couponDiscount, setCouponDiscount] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [basketIds, setBasketIds] = useState<string[]>([]);
  const [userBusinessPackage, setUserBusinessPackage] = useState<B2B>();
  const [formdData, setFormdData] = useState<any>({
    fullname: "",
    email: "",
    city: "",
    district: "",
    street: "",
    phone: "",
    openAddress: "",
    couponCode: "",
    totalPrice: 0,
  });
  // const [cargoFee] = useState<number>(40);

  const validationSchema = Yup.object({
    fullname: Yup.string().required("First and last name is mandatory."),
    email: Yup.string()
      .email("Invalid email address.")
      .required("Email is mandatory."),
    phone: Yup.string()
      .matches(/^[0-9]{10}$/, "Invalid phone number.")
      .required("Phone number is mandatory."),
    openAddress: Yup.string().required("Address is mandatory."),
    city: Yup.string().required("City is mandatory."),
    district: Yup.string().required("District is mandatory"),
    street: Yup.string().required("Street is mandatory."),
    status: Yup.boolean()
      .oneOf([true], "You must accept the distance sales contract.")
      .required("You must accept the distance sales contract."),
  });

  // FAKE DATA
  const dummyCouponCodes = [
    { code: "KUPONKODU1", discount: 500 },
    { code: "KUPONKODU2", discount: 1000 },
    { code: "KUPONKODU3", discount: 2000 },
  ];

  // FETCH CONTRACTS
  useEffect(() => {
    const getContracts = async () => {
      try {
        const response = await getFetcher(endpoints.auth.getContracts);
        if (response.result) {
          response.contracts.map((item: IContract) => {
            const myContaract = item.key === "distance_selling_contract";
            if (myContaract) {
              // setContract({
              //   key: item.key,
              //  value: item.value,
              // });
            } else {
              console.log("ERROR");
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    };
    getContracts();
  }, []);

  // GET USER BASKET
  useEffect(() => {
    // @ts-ignore
    const localUserId = parseStatics(localStorage.getItem("defaultUserId"));
    // console.log("localUserIdQWE", localUserId);
    if (!user) {
      const getUserBasket = async () => {
        setLoading(true);
        try {
          const userBasketResponse = await getFetcher(
            endpoints.user.getLocalBasket.replace("{userId}", localUserId)
          );
          if (userBasketResponse.result) {
            setBasketData(userBasketResponse);
            setTimeout(() => {
              setLoading(false);
            }, 500);
          } else {
            console.log("err");
          }
        } catch (error) {
          console.log(error);
          location.href = "/basket";
        }
      };
      getUserBasket();
    } else {
      const getUserBasket = async () => {
        setLoading(true);
        try {
          const userBasketResponse = await getFetcher(
            endpoints.user.getUserBasket
          );
          if (userBasketResponse.result) {
            setBasketData(userBasketResponse);
            setTimeout(() => {
              setLoading(false);
            }, 500);
          } else {
          }
        } catch (error) {
          console.log(error);
          location.href = "/basket";
        }
      };
      getUserBasket();
    }
  }, []);

  let id: any;
  // @ts-ignore
  const defaultUserId: any = parseStatics(   localStorage.getItem("defaultUserId"));

  if (user) {
    id = user?.id;
  } else {
    id = defaultUserId;
  }

  const formik = useFormik({
    initialValues: {
      fullname: user?.firstName + " " + user?.lastName || "",
      email: user?.email || "",
      city: user?.city || "",
      district: "",
      street: "",
      zipCode: "",
      country: "",
      phone: user?.phoneNumber || "",
      openAddress: user?.openAddress || "",
      couponCode: couponCode,
      totalPrice: totalPriceLast,
      status: false,
    },
    validationSchema,
    onSubmit: async (values) => {
      const fullAddress = {
        street: values.street,
        zipCode: values.zipCode,
        country: values.country,
      };

      setFormdData({
        fullname: values.fullname,
        email: values.email,
        city: values.city,
        district: values.district,
        street: values.street,
        zipCode: values.zipCode,
        country: values.country,
        phone: values.phone,
        openAddress: `${values.openAddress}, ${fullAddress.zipCode}, ${fullAddress.country}`,
        couponCode: values.couponCode,
        totalPrice: values.totalPrice,
      });
    },
  });

  useEffect(() => {
    setFormdData({
      fullname: formik.values.fullname,
      email: formik.values.email,
      city: formik.values.city,
      district: formik.values.district,
      street: formik.values.street,
      zipCode: formik.values.zipCode,
      country: formik.values.country,
      phone: formik.values.phone,
      openAddress: formik.values.openAddress,
      couponCode: formik.values.couponCode,
      totalPrice: formik.values.totalPrice,
    });
  }, [formik.values]);

  useEffect(() => {

    async function fetchBusinessPackageData() {
      if (user) {
        try {
          const businessPackage = await getFetcher(
            endpoints.user.getBusinessPackageById.replace(
              "{id}",
              user.businessPackageId
            )
          );
          if (businessPackage.result) {
            setUserBusinessPackage(businessPackage.businessPackage);
          }
        } catch (error) {
          console.error("Error fetching favorites:", error);
        }
      }
    }

    fetchBusinessPackageData();
  }, [formik.values]);

 const createOrder = async () => {
    try {
      const response = await postFetcher(endpoints.orders.createOrder, {
        arg: {
          id,
          basketIds: basketIds,
          customerName: formdData.fullname,
          customerPhone: formdData.phone,
          customerEmail: formdData.email,
          city: formdData.city,
          district: formdData.district,
          couponCode: couponCode,
          totalAmount: totalPrice,
          deliveryAddress:
            formdData.zipCode +
            " , " +
            formdData.country +
            " , " +
            formdData.openAddress,
          currency: currency,
        },
      });

      if (response.result) {
        if (user) {
          toast.success(t("toastMessage", "order1"), {
            hideProgressBar: true,
          });

          setTimeout(() => {
            window.location.href = response?.paymentLink;
          }, 2000);
        } else {
          toast.success(t("toastMessage", "order2"));
          setTimeout(() => {
            window.location.href = response?.paymentLink;
          }, 2000);
        }
      } else {
        if ((response.message = "All fields required")) {
          toast.error(t("toastMessage", "order3"));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // SET FORM DATA
  useEffect(() => {
    formik.setValues({
      fullname: (user && user?.firstName + " " + user?.lastName) || "",
      email: user?.email || "",
      city: user?.openAddress?.split("/")[0] || "",
      district:
        (user?.openAddress &&
          user?.openAddress?.split("/")[1]?.split(",")[0]) ||
        "",
      street: "",
      phone: user?.phoneNumber || "",
      openAddress: user?.openAddress,
      couponCode: couponCode,
      totalPrice: totalPriceLast,
      status: false,
    } as any);
  }, [user]);

  const textCut = (text: string, length: number) => {
    if (text.length > length) {
      return text.slice(0, length) + "...";
    } else {
      return text;
    }
  };

  // CALCULATE TOTAL PRİCE
  const calculateItemTotalPrice = (item: BasketItem): any => {
    const discountedPrice = calculateDiscountedPrice(
      item.product.price,
      item.product.discount,
      userBusinessPackage ? userBusinessPackage?.ratio : 0,
      exchangeRate
    ); // discount price
    let totalPrice = discountedPrice * item.quantity;

    if (item.bulkDiscount) {
      const bulkDiscountedPrice = parseFloat(calculateBulkDiscount(item));
      totalPrice = bulkDiscountedPrice;
    }

    //setNotCalculatedDailyOrCompanyPrice(totalPrice);

    return totalPrice;
  };

  const calculateBulkDiscount = (item: BasketItem) => {
    const bulkDiscounts = item.product.bulkDiscounts
      ? item.product.bulkDiscounts
      : [];

    const discountPrice = calculateDiscountedPrice(
      item.product.price,
      item.product.discount,
      userBusinessPackage ? userBusinessPackage?.ratio : 0,
      exchangeRate
    );

    if (item.bulkDiscount) {
      const applicableBulkDiscount = bulkDiscounts
        .filter((bulk: any) => item.quantity >= bulk.quantity)
        .sort((a: any, b: any) => b.quantity - a.quantity)[0];

      if (applicableBulkDiscount) {
        const totalPrice = discountPrice * item.quantity;
        const totalDiscountAmount =
          (totalPrice * applicableBulkDiscount.discount) / 100; // Yüzde indirim hesaplandı
        const bulkPrice = (totalPrice - totalDiscountAmount).toFixed(2);

        return bulkPrice;
      } else {
        return (discountPrice * item.quantity).toFixed(2);
      }
    } else {
      return (discountPrice * item.quantity).toFixed(2);
    }
  };

  // CALCULATE TOTAL PRİCE LAST
  useEffect(() => {
    const calculateTotalPriceLast = () => {
      if (basketData) {
        const totalPrice = basketData.basketItems.reduce((sum, item) => {
          const discountedPrice = calculateDiscountedPrice(
            item.product.price,
            item.product.discount,
            userBusinessPackage ? userBusinessPackage?.ratio : 0,
            exchangeRate
          );

          return sum + discountedPrice * item.quantity;
        }, 0);
        setTotalPriceLast(totalPrice);
      }
    };

    calculateTotalPriceLast();
  }, [basketData]);

  const groupedBasketData: any = basketData?.basketItems?.reduce(
    (acc: Record<string, any[]>, item) => {
      const code = item.product?.code;
      if (!code) return acc;

      if (!acc[code]) {
        acc[code] = [];
      }
      acc[code].push(item);

      return acc;
    },
    {}
  );

  const calculateGroupedBulkDiscount = (basketItems: BasketItem[]): number => {
    const productGroups: {
      [key: string]: { totalQuantity: number; unitPrice: number };
    } = {};

    basketItems.forEach((item) => {
      const discountedUnitPrice = calculateDiscountedPrice(
        item.product.price,
        item.product.discount,
        userBusinessPackage ? userBusinessPackage.ratio : 0,
        exchangeRate
      );

      if (productGroups[item.product.code]) {
        productGroups[item.product.code].totalQuantity += item.quantity;
      } else {
        productGroups[item.product.code] = {
          totalQuantity: item.quantity,
          unitPrice: discountedUnitPrice,
        };
      }
    });

    let totalDiscountedPrice = 0;

    Object.keys(productGroups).forEach((productCode) => {
      const { totalQuantity, unitPrice } = productGroups[productCode];

      const bulkDiscountsArray = (basketData?.basketItems || []).flatMap(
        (item: any) =>
          item.product?.bulkDiscounts?.map((discountItem: any) => ({
            quantity: discountItem.quantity,
            discount: discountItem.discount,
          })) || []
      );

      const applicableDiscount = bulkDiscountsArray
        .filter((discount) => totalQuantity >= discount.quantity)
        .sort((a, b) => b.quantity - a.quantity)[0];

      let productTotalPrice = unitPrice * totalQuantity;

      if (applicableDiscount) {
        const discountAmount =
          (productTotalPrice * applicableDiscount.discount) / 100;
        productTotalPrice -= discountAmount;
      }

      totalDiscountedPrice += productTotalPrice;
    });

    return parseFloat(totalDiscountedPrice.toFixed(2));
  };

  const totalPrice: number =
    groupedBasketData && Object.keys(groupedBasketData).length > 0 && basketData
      ? calculateGroupedBulkDiscount(basketData?.basketItems)
      : basketData?.basketItems.reduce(
          (sum, item) => sum + calculateItemTotalPrice(item),
          0
        ) || 0;

  const totalOriginalPrice: number =
    basketData?.basketItems.reduce(
      (sum, item) => sum + item.product.price * item.quantity * exchangeRate,
      0
    ) || 0;

  const totalDiscountAmount = totalOriginalPrice - totalPrice;
  const totalDiscountPercentage =
    (totalDiscountAmount / totalOriginalPrice) * 100;

  // COUPON CODE
  const handleClickCouponFN = () => {
    if (couponCode) {
      const coupon = dummyCouponCodes.find((item) => item.code === couponCode);
      if (coupon) {
        setCouponDiscount(coupon.discount);
        toast.success(t("toastMessage", "order4"));
      } else {
        toast.error(t("toastMessage", "order5"));
      }
    } else {
      toast.error(t("toastMessage", "order6"));
    }
  };

  // BASKET IDS
  useEffect(() => {
    setBasketIds(basketData?.basketItems.map((item) => item?.id) || []);
  }, [basketData]);
  
  return (
    <div className="flex flex-col min-h-screen ">
      {/* <Header />
      <Navbar /> */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <main className="mb-20">
        <div className="container mx-auto px-4 py-8 ">
          <h1 className="text-center text-3xl font-semibold pt-12 ">
            {t("safePayment", "title")}
          </h1>
          <div className="border-b-2 border-color-gray py-6 mb-8 mx-auto"></div>
          <div className="gap-16 space-y-36">
            {/*TOP SECTION */}
            <div className="flex w-full gap-16 flex-col xl:flex-row ">
              {/* BILLING / SHIPPING ADDRESS */}
              <div className="w-full xl:w-1/2 bg-white p-6 rounded-lg shadow-md h-auto">
                <h2 className="text-xl font-bold text-primary-color mb-4">
                  {t("safePayment", "address")}
                </h2>
                <form className="space-y-4" onSubmit={formik.handleSubmit}>
                  {/* PERSONAL INFO SECTION */}
                  <input
                    type="text"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-color"
                    name="fullname"
                    value={formik.values.fullname}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Name, Surname"
                  />
                  {formik.touched.fullname && formik.errors.fullname ? (
                    <div className="text-red-500 text-sm">
                      {formik.errors.fullname}
                    </div>
                  ) : null}

                  <input
                    type="email"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-color"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Email"
                    name="email"
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <div className="text-red-500 text-sm">
                      {formik.errors.email}
                    </div>
                  ) : null}

                  <div className="grid grid-cols-2 gap-4">
                    <div className="relative">
                      <input
                        type="text"
                        id="city"
                        name="city"
                        value={formik.values.city}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        placeholder="City"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-color"
                      />
                      {formik.touched.city && formik.errors.city ? (
                        <div className="text-black text-sm">
                          {formik.errors.city}
                        </div>
                      ) : null}
                    </div>

                    <div className="relative">
                      <input
                        type="text"
                        id="district"
                        name="district"
                        value={formik.values.district}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        placeholder="District"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-color"
                      />
                      {formik.touched.district && formik.errors.district ? (
                        <div className="text-black text-sm">
                          {formik.errors.district}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  {/* Street, Zip Code and Country Fields */}
                  <div className="grid grid-cols-2 gap-4">
                    <div className="relative col-span-2">
                      <input
                        type="text"
                        name="street"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-color"
                        placeholder="Street"
                        value={formik.values.street}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.street && formik.errors.street ? (
                        <div className="text-red-500 text-sm">
                          {formik.errors.street}
                        </div>
                      ) : null}
                    </div>

                    <div className="relative">
                      <input
                        type="text"
                        name="zipCode"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-color"
                        placeholder="Zip Code"
                        value={formik.values.zipCode}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.zipCode && formik.errors.zipCode ? (
                        <div className="text-red-500 text-sm">
                          {formik.errors.zipCode}
                        </div>
                      ) : null}
                    </div>

                    <div className="relative">
                      <input
                        type="text"
                        name="country"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-color"
                        placeholder="Country"
                        value={formik.values.country}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.country && formik.errors.country ? (
                        <div className="text-red-500 text-sm">
                          {formik.errors.country}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <input
                    type="text"
                    name="phone"
                    placeholder="Phone number"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-color"
                    title="Telefon numarası formatı: 5XX XXX XXXX"
                    value={formik.values.phone}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.phone && formik.errors.phone ? (
                    <div className="text-red-500 text-sm">
                      {formik.errors.phone}
                    </div>
                  ) : null}

                  <input
                    type="text"
                    name="openAddress"
                    placeholder="Open address"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-color"
                    value={formik.values.openAddress}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.openAddress && formik.errors.openAddress ? (
                    <div className="text-red-500 text-sm">
                      {formik.errors.openAddress}
                    </div>
                  ) : null}
                </form>
              </div>

              {/* ORDER SUMMARY */}
              <div className="w-full xl:w-1/2 bg-white p-6 rounded-lg shadow-md flex flex-col justify-between h-auto">
                <div>
                  <h2 className="text-xl font-bold mb-4">
                    {t("safePayment", "orderSummary")}
                  </h2>
                  {/* BASKET ITEMS */}
                  {loading ? (
                    <div className=" w-full h-[250px] flex items-center justify-center">
                      <Spinner />
                    </div>
                  ) : (
                    basketData?.basketItems?.map(
                      (item: BasketItem, index: number) => {
                        const parsedImage = item?.product?.images;
                        const attributes: any = item?.attributes || {};
                        return (
                          <div key={index} className="flex items-center mb-5">
                            <div className=" relative">
                              <img
                                src={parsedImage[0]}
                                alt="Product"
                                className="w-16 h-16 object-cover rounded-md mr-4"
                              />
                              <div className=" absolute -top-3 right-2 font-bold bg-primary-color w-[23px] h-[23px] rounded-full text-white flex justify-center items-center text-xxs ">
                                {item?.quantity}
                              </div>

                              <div className=" -top-3 absolute -left-5">
                                <div className=" text-xxs font-bold text-primary-color">
                                  {item?.product?.brand}
                                </div>
                              </div>
                            </div>
                            <div className="flex flex-col select-none">
                              <Tooltip content={item?.product?.name}>
                                <span className=" font-light md:font-semibold text-[11px] md:text-sm">
                                  {textCut(item?.product?.name, 30)}
                                </span>
                              </Tooltip>
                              {/* ATTRİBUTES */}
                              <div className=" flex flex-wrap gap-2 mt-1 text-xs sm:text-sm text-color-bold-gray  items-center ">
                                {attributes?.Color && (
                                  <p
                                    style={{
                                      backgroundColor: attributes.Color,
                                    }}
                                    className={`font-semibold capitalize w-3 h-3 rounded-full`}
                                  ></p>
                                )}
                                {attributes.Size && (
                                  <p className="font-semibold capitalize">
                                    {attributes?.Size}
                                  </p>
                                )}
                                {attributes.Weight && (
                                  <p className="font-semibold capitalize">
                                    {attributes?.Weight}
                                  </p>
                                )}
                                {attributes.Ml && (
                                  <p className="font-semibold capitalize">
                                    {attributes?.Ml}
                                  </p>
                                )}
                              </div>
                              <div>
                                {item.bulkDiscount == true && (
                                  <p className="text-primary-color text-xs font-semibold">
                                    ({t("safePayment", "bulkDiscount")})
                                  </p>
                                )}
                              </div>

                              <div className=" text-xxs flex gap-x-5 font-bold mt-1  ">
                                <div className=" flex gap-x-1">
                                  <p className=" text-primary-color">
                                    {item.product.Supplier.marketPlaceName}
                                  </p>{" "}
                                  <p>Şirketi</p>
                                </div>
                              </div>
                            </div>
                            <div className="ml-auto text-right flex flex-col md:flex-row gap-x-3 items-center justify-center">
                              <span className=" text-color-bold-gray line-through">
                                {currencySymbol}
                                {(
                                  item.product.price *
                                  item?.quantity *
                                  exchangeRate
                                ).toFixed(2)}
                              </span>
                              <span className="block font-semibold">
                                {currencySymbol}
                                {item?.bulkDiscount == true
                                  ? calculateBulkDiscount(item)
                                  : calculateItemTotalPrice(item).toFixed(2)}
                              </span>
                            </div>
                          </div>
                        );
                      }
                    )
                  )}
                  <div className="flex gap-4 my-6">
                    <input
                      type="text"
                      placeholder={t("safePayment", "codePlaceHolder")}
                      className=" w-2/3  px-2 py-2  border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-color"
                      value={couponCode}
                      onChange={(e) => setCouponCode(e.target.value)}
                    />
                    <button
                      onClick={handleClickCouponFN}
                      className="bg-primary-color text-white w-1/3 rounded-md active:scale-95 transition"
                    >
                      {t("safePayment", "applyButton")}
                    </button>
                  </div>
                  <div className="flex justify-between items-center mb-4">
                    <span className="text-gray-700">
                      {t("safePayment", "total")}
                    </span>
                    <span className="font-semibold">
                      {currencySymbol}
                      {totalPrice?.toFixed(2)}
                    </span>
                  </div>
                  {/* <div className="flex justify-between items-center mb-4">
                    <span className="text-gray-700">Kargo</span>
                    <span className="font-semibold">{formatPrice(cargoFee)}</span>
                  </div> */}
                  <div className="flex justify-between items-center mb-4">
                    <span className="text-gray-700">
                      {t("safePayment", "totalPrice")}
                    </span>
                    <div className=" flex gap-x-3">
                      <span className="text-white font-bold text-xs p-1  rounded flex justify-center items-center bg-green-700 select-none">
                        %{totalDiscountPercentage?.toFixed(2)}
                      </span>
                      <span className=" line-through text-color-bold-gray font-bold">
                        {currencySymbol}
                        {totalOriginalPrice?.toFixed(2)}
                      </span>
                      <span className="font-semibold">
                        {couponDiscount ? (
                          <div>
                            {currencySymbol}
                            {(totalPrice - couponDiscount)?.toFixed(2)}
                          </div>
                        ) : (
                          <div>
                            {currencySymbol}
                            {totalPrice?.toFixed(2)}
                          </div>
                        )}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="mt-4 w-full">
                  <button
                    onClick={createOrder}
                    className="bg-primary-color text-white w-full py-2 rounded-md active:scale-105 transition"
                  >
                    {t("safePayment", "confirmButton")}
                  </button>
                  {/*                   
                    <div className=" flex justify-center items-center flex-col">
                          <p className=" text-color-bold-gray text-sm ">(Lütfen Sözleşmeyi okuyun ve kabul edin)</p>
                          <button className="bg-gray-300 text-white py-2 !w-full rounded-md active:scale-105 transition cursor-not-allowed">
                            Siparişi Tamamla
                          </button>
                        </div>
                    */}
                </div>
              </div>
            </div>

            {/*BOTTOM SECTION */}
            <div className="flex w-full gap-16 flex-col md:flex-row">
              {/*REMİNDER*/}
              <div className="w-full md:w-11/12 mx-auto bg-white p-6 rounded-lg shadow-md flex flex-col justify-between h-auto max-h-[400px]">
                <div className="overflow-y-auto">
                  <h2 className="text-2xl font-bold text-primary-color mb-4 text-center">
                    {t("safePayment", "reminder")}
                  </h2>
                  <p className="text-sm text-gray-700">
                    {/* Size değerli müşterilerimizden biri olarak bilgilendirme
                    yapmak istiyoruz. Satın aldığınız kampanyalı ürünlerde
                    sunulan özel fırsatlarımızdan faydalandığınız için teşekkür
                    ederiz. Bizim "100 adet ürün al, 5 tanesi bedava" gibi
                    kampanyalarımızda, ücretsiz olarak aldığınız ürünlerin
                    iadesi durumunda, bedava olarak verilen ürünlerin de
                    iadesinin gerektiğini hatırlatmak isteriz. Bu prosedür,
                    kampanya koşulları gereğidir ve iade işlemi sırasında göz
                    önünde bulundurulmalıdır. İade sürecinizde herhangi bir
                    sorun yaşamamak ve işlemi hızlı bir şekilde tamamlamak için
                    lütfen aşağıdaki adımları takip edin:
                    <ol className="list-decimal list-inside font-semibold pl-2">
                      <li>
                        İade edeceğiniz ürünlerin orijinal ambalajında ve
                        kullanılmamış durumda olmasına dikkat edin.
                      </li>
                      <li>
                        İade talebinizi siparişlerim, detay ve iade et
                        adımlarıyla sağlayabilirsiniz.
                      </li>
                      <li>
                        İade talebinizi oluştururken, aldığınız kampanyalı
                        ürünlerin ücretsiz olarak verilenlerini de listeye
                        ekleyin.
                      </li>
                    </ol>
                    Herhangi bir iade sürecinde veya başka bir konuda yardıma
                    ihtiyacınız olursa, lütfen bizimle iletişime geçmekten
                    çekinmeyin. Size yardımcı olmaktan memnuniyet duyarız. */}
                    {t("safePayment", "reminderText")}
                  </p>
                </div>
              </div>

              {/*TERMS AND CONDITIONS
              <div className="w-full md:w-1/2 bg-white p-6 rounded-lg shadow-md flex flex-col justify-between h-auto max-h-[400px]">
                <div
                  className={`flex-grow space-y-6 overflow-y-auto ${styles.scrollableSection}`}
                >
                  <h2 className="text-xl font-bold mb-4">
                    Sözleşme ve Formlar
                  </h2>
                  <div>
                    <Accordion>
                      <Accordion.Panel>
                        <Accordion.Title>
                          Mesafeli Satış Sözleşmesi
                        </Accordion.Title>
                        <Accordion.Content>
                          <div
                            className="contract-content h-64 overflow-y-scroll"
                            dangerouslySetInnerHTML={{ __html: contract.value }}
                          />
                        </Accordion.Content>
                      </Accordion.Panel>
                    </Accordion>
                  </div>
                </div>
                <div className="mt-4">
                  {confirmContract ? (
                    <button className="bg-primary-color text-white w-full py-2 rounded-md active:scale-95 transition flex justify-center items-center gap-x-5">
                      <p>Kabul Ediyorum</p>
                      <FaCheckCircle size={25} />
                    </button>
                  ) : (
                    <button onClick={() => setConfirmContract(true)} className="bg-primary-color text-white w-full py-2 rounded-md active:scale-95 transition flex justify-center items-center gap-x-5">
                      <p>Kabul Ediyorum</p>
                      <MdErrorOutline size={25} />
                    </button>
                  )}
                </div>
              </div>
              */}
            </div>
          </div>
        </div>
      </main>
      {/* <Footer /> */}
    </div>
  );
};

export default SafePayment;
